import React, { useEffect, useRef, useState } from 'react';
import CrossIcon from "../../../../assets/img/svg/svgComponents/CrossIcon"
import { Card, CardBody } from 'reactstrap';
import { formatNotificationType, notificationConfigList } from './constant';
import ToggleSwitch from 'views/pages/manage/common/form-fields-mui/ToggleSwitch';
import ALoader from 'views/pages/manage/common/a-loader';
const NotificationConfig = ({
    closeForm,
    hasUpdate = true,
    statusValue,
    view = false,
    notificationConfig,
    handleNotificationConfig,
    userPermissions
}) => {
    const [notiLoader, setNotiLoader] = useState()
    const [value, setValue] = useState(statusValue);
    useEffect(() => {
        setValue((prev) => (statusValue))
    }, [statusValue])


    const containerRef = useRef(null); // Step 1: ref

    const onToggleClick = async (item) => {
        // setValue(prev => ({
        //     ...prev,
        //     [key]: prev?.[key] === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE'
        // }));
        try {
            setNotiLoader(true)
            const req = { id: item?.id, status: item?.status == 'ACTIVE' ? 'INACTIVE' : 'ACTIVE' }
            await handleNotificationConfig(req)
        }
        catch (err) {
            console.error(err);
        }
        finally {
            setNotiLoader(false)
        }
    };
    return (
        <>
        {notiLoader&& <ALoader position= 'fixed'/>}
        <Card className="mb-0 regular-body label-color"
            style={{ width: "auto", borderRadius: "12px" }}>
            <CardBody className="d-flex flex-column">
                <div className="mb-1 d-flex align-items-start justify-content-between">
                    <div className="semi-bolder">Notification config</div>
                    <span onClick={closeForm} className='cursor semi-bolder'><CrossIcon /></span>
                </div>
                <div
                    className="d-flex flex-column"
                    style={{ gap: '16px', paddingTop: '24px' }}
                >
                    {notificationConfig.map((item, idx) => (<>
                        <div
                            key={idx}
                            className="cursor d-flex justify-content-between align-items-center"
                        >
                            <div className="regular-bold color-grey-80" style={{ width: '150px' }}>
                                {formatNotificationType(item?.notificationType)}
                            </div>
                            <div>

                                <ToggleSwitch
                                    checked={item.status === "ACTIVE"}
                                    onClick={() =>
                                        onToggleClick(item)
                                    }
                                disabled={!userPermissions?.includes("U")}
                                />
                            </div>
                        </div>
                        {idx != handleNotificationConfig.length - 1 && <div className='mx-0' style={{ borderBottom: " 1px solid #E2E2E2" }}></div>}
                    </>
                    ))}
                </div>
            </CardBody>
        </Card>
        </>
    )
}
export default NotificationConfig;